const PhotoSwipe = require('photoswipe');
const PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');
const galleryItems = document.querySelectorAll('.galleryItem');
const photoSwipeModal = document.querySelectorAll('.photoSwipeModal')[0];
const items = [];
const galleryTrigger = document.querySelector('.galleryTrigger');

if (galleryItems) {
    // Loop over gallery items and push it to the array
    galleryItems.forEach( (item) => {
        let metadata = {
            src: item.href,
            w: item.dataset.width,
            h: item.dataset.height
        }

        items.push(metadata);

        // on click of gallery item
        item.addEventListener('click', (e) => {
            // Prevent location change
            e.preventDefault();

            let posStartsZero = parseInt(item.dataset.pos, 10) - 1;

            // Add options
            const options = {
                // get index and convert to integer
                index: posStartsZero,
                bgOpacity: 0.85,
                showHideOpacity: true,
                closeOnScroll: false,
            };

            // Initialise PhotoSwipe
            const gallery = new PhotoSwipe(photoSwipeModal, PhotoSwipeUI_Default, items, options);
            gallery.init();
        })
    })

    if (galleryTrigger) {

        galleryTrigger.addEventListener('click', () => {
            // Add options
            const options = {
                // get index and convert to integer
                index: 0,
                bgOpacity: 0.85,
                showHideOpacity: true,
                closeOnScroll: false,
            };

            // Initialise PhotoSwipe
            const gallery = new PhotoSwipe(photoSwipeModal, PhotoSwipeUI_Default, items, options);
            gallery.init();
        })
    }
}
